(function() {
  let submitButton = null;
  let formSubmitted = false;
  let buttonClicked = false;
  let shadowRoot = null;

  // Shadow DOM içinde element arama fonksiyonu
  function findInShadowDOM(selector) {
    let element = document.querySelector(selector);
    if (element) return element;

    if (!shadowRoot) {
      const formsEmbed = document.querySelector('shopify-forms-embed');
      if (formsEmbed && formsEmbed.shadowRoot) {
        shadowRoot = formsEmbed.shadowRoot;
      }
    }

    if (shadowRoot) {
      element = shadowRoot.querySelector(selector);
      if (element) return element;
    }

    return null;
  }

  // Country değerini alma fonksiyonu
  function getCountryValue() {
    const countryElement = findInShadowDOM('._selectToggleText_12thd_25');
    return countryElement ? countryElement.textContent.trim() : '';
  }

  // Submit başarısını kontrol eden fonksiyon
  function checkSubmitSuccess(savedCountry) {
    const formFieldsetRemoved = !findInShadowDOM('._formFieldset_cit2d_82');
    const successBannerAdded = findInShadowDOM('[data-testid="banner-success"]');

    if (formFieldsetRemoved && successBannerAdded && !formSubmitted) {
      formSubmitted = true;

      const country = savedCountry || '';
      console.log('Country:', country);

      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'EUWholesaleForm', {country: country});
      }
    }
  }

  // Button click handler
  function attachButtonListener(button) {
    if (!button.dataset.listenerAttached) {
      button.dataset.listenerAttached = 'true';
      let savedCountry = null;

      button.addEventListener('click', function(e) {
        buttonClicked = true;
        savedCountry = getCountryValue();

        setTimeout(function checkLoop() {
          if (!formSubmitted) {
            checkSubmitSuccess(savedCountry);
            if (!formSubmitted && buttonClicked) {
              setTimeout(checkLoop, 500);
            }
          }
        }, 500);
      });
    }
  }

  // Button'u bul ve listener ekle
  function findAndAttachButton() {
    if (!submitButton) {
      const button = findInShadowDOM('._formSubmitButton_cit2d_96');
      if (button) {
        submitButton = button;
        attachButtonListener(button);
        return true;
      }
    }
    return false;
  }

  // MutationObserver - DOM değişikliklerini izle
  const observer = new MutationObserver(function(mutations) {
    findAndAttachButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-testid']
  });

  // Periyodik kontrol - setInterval ile sürekli kontrol et
  let checkCount = 0;
  const checkInterval = setInterval(function() {
    checkCount++;

    if (findAndAttachButton()) {
      clearInterval(checkInterval);
    }

    if (checkCount >= 40) {
      clearInterval(checkInterval);
    }
  }, 500);

  // Shadow root için de observer ekle
  setTimeout(function() {
    if (shadowRoot) {
      const shadowObserver = new MutationObserver(function(mutations) {
        findAndAttachButton();
      });

      shadowObserver.observe(shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-testid']
      });
    }
  }, 2000);
})();